import React, { useEffect, useState } from "react";
import AddButton from "../../../../components/admin/usable/AddButton";
import { useDispatch, useSelector } from "react-redux";
import {
  setForAll,
  setIsSingleSelected,
  setShowFileUploader,
  setSingleSelected,
} from "../../../../redux/admin/fileManagerSlice";
import FileUploadandSelect from "../../../../components/admin/usable/fileuploader/FileUploadandSelect";
import {
  addBanner,
  getBannerData,
  updateBanner,
} from "../../../../api/admin/homePageApi";
import toast from "react-hot-toast";

const BannerOne = () => {
  const dispatch = useDispatch();
  const { showFileUploader, singleSelected } = useSelector(
    (state) => state.file,
  );
  const [FormData, setFormData] = useState({
    id: "",
    bannerOne: "",
    linkOne: "",
    bannerTwo: "",
    linkTwo: "",
    bannerThree: "",
    linkThree: "",
  });
  const [ActiveField, setActiveField] = useState(null);

  useEffect(() => {
    dispatch(setForAll(true));
    dispatch(setIsSingleSelected(true));
    return () => {
      dispatch(setForAll(false));
      dispatch(setIsSingleSelected(false));
    };
  }, [dispatch]);
  useEffect(() => {
    getBannerData(setFormData);
  }, []);
  useEffect(() => {
    if (singleSelected && ActiveField === "bannerOne") {
      setFormData((prevData) => ({
        ...prevData,
        bannerOne: singleSelected.fileLink.medium || "",
      }));
      setActiveField(null);
      dispatch(setSingleSelected(null));
    } else if (singleSelected && ActiveField === "bannerTwo") {
      setFormData((prevData) => ({
        ...prevData,

        bannerTwo: singleSelected.fileLink.medium || "",
      }));
      setActiveField(null);
      dispatch(setSingleSelected(null));
    } else if (singleSelected && ActiveField === "bannerThree") {
      setFormData((prevData) => ({
        ...prevData,

        bannerThree: singleSelected.fileLink.medium || "",
      }));
      setActiveField(null);
      dispatch(setSingleSelected(null));
    }
  }, [singleSelected, dispatch, ActiveField]);
  const handleShowFileManager = (field) => {
    setActiveField(field);
    dispatch(setShowFileUploader(true));
    dispatch(setForAll(true));
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const handleSubmit = () => {
    if (
      !FormData.bannerOne === "" ||
      !FormData.linkOne === "" ||
      !FormData.bannerTwo === "" ||
      !FormData.linkTwo === "" ||
      !FormData.bannerThree === "" ||
      !FormData.linkThree === ""
    ) {
      toast.error("Please fill all the fields");
    } else {
      if (FormData.id) {
        updateBanner(FormData, setFormData);
      } else {
        addBanner(FormData, setFormData);
      }
    }
  };

  return (
    <>
      {showFileUploader && <FileUploadandSelect />}
      <div className="w-full h-auto border p-3 bg-white rounded-lg space-y-5">
        <div>
          <p className="text-m font-medium">Banner Section</p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
          <div className="w-full h-auto space-y-3">
            <div>
              <label className="text-xs">Banner One</label>
              <div>
                <div className="relative w-full h-52">
                  <img
                    className="w-full h-52 object-cover rounded-lg"
                    src={
                      FormData.bannerOne
                        ? FormData.bannerOne
                        : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3dSEtDvpd9KAn4SdFJVoL0K1lj4Xfc-wVWQ&s"
                    }
                    alt=""
                  />

                  <div
                    onClick={() => handleShowFileManager("bannerOne")}
                    className="opacity-0 hover:opacity-100 absolute inset-0 bg-black/20 px-3 py-1 border cursor-pointer flex justify-center items-center duration-300 rounded-lg w-full h-52"
                  >
                    <p className="font-bold text-xs">Upload Now</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <label className="text-xs">Link One</label>
              <input
                type="text"
                placeholder="Banner One Link"
                className="w-full px-4 py-2 text-sm rounded-lg border focus:outline-none"
                id="linkOne"
                value={FormData.linkOne}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="w-full h-auto space-y-3">
            <div>
              <label className="text-xs">Banner Two</label>
              <div>
                <div className="relative w-full h-52">
                  <img
                    className="w-full h-52 object-cover rounded-lg"
                    src={
                      FormData.bannerTwo
                        ? FormData.bannerTwo
                        : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3dSEtDvpd9KAn4SdFJVoL0K1lj4Xfc-wVWQ&s"
                    }
                    alt=""
                  />

                  <div
                    onClick={() => handleShowFileManager("bannerTwo")}
                    className="opacity-0 hover:opacity-100 absolute inset-0 bg-black/20 px-3 py-1 border cursor-pointer flex justify-center items-center duration-300 rounded-lg w-full h-52"
                  >
                    <p className="font-bold text-xs">Upload Now</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <label className="text-xs">Link Two</label>
              <input
                type="text"
                placeholder="Banner Two Link"
                className="w-full px-4 py-2 text-sm rounded-lg border focus:outline-none"
                id="linkTwo"
                value={FormData.linkTwo}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="w-full h-auto space-y-3">
            <div>
              <label className="text-xs">Banner Three</label>
              <div>
                <div className="relative w-full h-52">
                  <img
                    className="w-full h-52 object-cover rounded-lg"
                    src={
                      FormData.bannerThree
                        ? FormData.bannerThree
                        : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3dSEtDvpd9KAn4SdFJVoL0K1lj4Xfc-wVWQ&s"
                    }
                    alt=""
                  />

                  <div
                    onClick={() => handleShowFileManager("bannerThree")}
                    className="opacity-0 hover:opacity-100 absolute inset-0 bg-black/20 px-3 py-1 border cursor-pointer flex justify-center items-center duration-300 rounded-lg w-full h-52"
                  >
                    <p className="font-bold text-xs">Upload Now</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <label className="text-xs">Link Three</label>
              <input
                type="text"
                placeholder="Banner Three Link"
                className="w-full px-4 py-2 text-sm rounded-lg border focus:outline-none"
                id="linkThree"
                value={FormData.linkThree}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>
        <div className="flex justify-end items-end gap-2">
          <AddButton
            onClick={handleSubmit}
            text={`${FormData.id ? "Update Now" : "Add Now"}`}
            size="md"
          />
        </div>
      </div>
    </>
  );
};

export default BannerOne;
